<template>
    <div class="">
        <div class="form-group">
            <label>Titel der Seite</label>
            <input type="text" class="form-control" v-model="config.title" :placeholder="'Seite ' + (index + 1)">
        </div>

        <grouping :options="options" :is-parent-grouping="true" :dto="config.parentGrouping"></grouping>
        <grouping :options="options" :is-parent-grouping="false" :dto="config.childrenGrouping"></grouping>

    </div>
</template>

<script>
import Grouping from "./Grouping.vue";

export default {
    components: {Grouping},
    props: {
        options: {
            type: Object,
            required: true
        },
        dto: {
            type: Object,
            required: true
        },
        index: {
            type: Number,
            required: true
        },
    },
    data() {
        return {
            config: this.dto
        };
    }
}
</script>
